import { formatFullDate, formatsEnum } from '../utils/formatUtils';

import { apiYclickMaster } from './apiInstances';

export const MYROLS = 'MYROLS';
export const ROLSANDPERMS = 'ROLSANDPERMS';

export const getRols = () =>
  apiYclickMaster
    .get(`v1/Roles/me?modulo=SERV`)
    .then((data) => {
      const roles = [];

      data?.data?.forEach((rol) => {
        roles.push(rol);
      });

      sessionStorage.setItem(MYROLS, JSON.stringify(roles));

      return roles;
    })
    .catch((error) => ({
      success: false,
      message: error.message
    }));

export const getRolsMe = () =>
  apiYclickMaster
    .get(`v1/Roles/me?modulo=SERV`)
    .then((data) => {
      const roles = [];

      data?.data?.forEach((rol) => {
        roles.push(rol);
      });

      sessionStorage.setItem(MYROLS, JSON.stringify(roles));

      return {
        success: true
      };
    })
    .catch((error) => ({
      success: false,
      message: error.message
    }));

export const getRolsAndPermissions = () =>
  apiYclickMaster
    .get(`/v1/Roles/permissions?modulo=SERV`)
    .then((res) => {
      if (res.status === 200) {
        const { data } = res;
        const roles = [];

        data?.forEach((rol) => {
          roles.push(rol);
        });
        sessionStorage.setItem(ROLSANDPERMS, JSON.stringify(roles));

        return {
          success: true
        };
      }

      return {
        success: false
      };
    })
    .catch((error) => ({
      success: false,
      message: error.message
    }));

export const getRolesMeYClick = (mod = 'SERV') => apiYclickMaster.get(`v1/Roles/me?modulo=${mod}`);

export const getRolesAndPermissionsYClick = (mod = 'SERV') =>
  apiYclickMaster.get(`/v1/Roles/permissions?modulo=${mod}`);

export const getYClickRolesAndPermissions = () =>
  new Promise((resolve, reject) => {
    Promise.all([getRolesAndPermissionsYClick('SERV'), getRolesAndPermissionsYClick('CERT')])
      .then(([resSer, resCertif]) => {
        const rolesJoined = [...resSer.data, ...resCertif.data];

        resolve(rolesJoined);
      })
      .catch((err) => reject(err));
  });

export const getYClickRolesMe = () =>
  new Promise((resolve, reject) => {
    Promise.all([getRolesMeYClick('SERV'), getRolesMeYClick('CERT')])
      .then(([resSer, resCertif]) => {
        const rolesJoined = [...resSer.data, ...resCertif.data];
        const rolesMap = rolesJoined.map((item) => [item.id, item]);
        const rolesMapArr = new Map(rolesMap);

        resolve([...rolesMapArr.values()]);
      })
      .catch((err) => reject(err));
  });

// ------------------ UBICACIONES -----------------------------------------------------------
export const getImputationType = async () => {
  const result = await apiYclickMaster.get(`/v1/Imputaciones/tiposImputacion`);

  return result.data;
};

export const getBusinessUnitsPozos = async (wellId) => {
  const params = new URLSearchParams();

  if (wellId) {
    params.append('idPozo', wellId);
  }
  const result = await apiYclickMaster.get(`/v1/UnidadesNegocio/pozos?${params.toString()}`);

  return result.data;
};

export const getBusinessUnitsLocations = async (locationId) => {
  const params = new URLSearchParams();

  if (locationId) {
    params.append('idLocacion', locationId);
  }
  const result = await apiYclickMaster.get(`/v1/UnidadesNegocio/locaciones?${params.toString()}`);

  return result.data;
};

/**
 *
 * @param {{ tipoUbicacionId: number, instalacionId?: number, ubicacionId?: number }} body
 * @returns {Promise<{codigoSAP: string, id: number, nombre: string}[]>}
 */
export const getOperationsOyM = async (body) => {
  const result = await apiYclickMaster.post(`v1/UbicacionesTecnicas/Operaciones`, body);

  return result.data;
};

/**
 * @param {{body: {nombre: string, tipoUbicacionId: number, operacionId: number}, ubicacionId: string}} params
 * @returns {Promise<{codigoSAP: string, id: number, nombre: string}[]>}
 */
export const getInstallationsOyM = async ({ body }) => {
  const result = await apiYclickMaster.post(`v1/UbicacionesTecnicas/instalaciones`, body);

  return result.data;
};

export const getUbicationsOyM = async (body) => {
  const result = await apiYclickMaster.post('v1/UbicacionesTecnicas/denominaciones', body);

  return result.data;
};

export const getClassifications = async ({ body }) => {
  const result = await apiYclickMaster.post(`/v1/UbicacionesTecnicas/clasificaciones`, body);

  return result.data;
};

export const getEventsWell = async (idPozo) => {
  const result = await apiYclickMaster.get(`/v1/Pozos/${idPozo}/eventos`);

  return result.data;
};

export const getEventsWellTeam = async (idEventoPozo, allTeams) => {
  const result = await apiYclickMaster.get(
    `/v1/Eventos/${idEventoPozo ?? null}/equipos/?todos=${allTeams}`
  );

  return result.data;
};

export const getUbicationsWell = async (wellName, locacionId, UnidadNegocioId) => {
  const baseUrl = '/v1/Ubicaciones/pozos';
  const result = await apiYclickMaster.get(
    `${baseUrl}?name=${wellName}&locacionId=${locacionId}&unidadNegocioId=${UnidadNegocioId}`
  );

  return result.data;
};

// Trae los pozos aunque allamos sellecionado o no una unidad de negocio en especifico
// Pero solo va a traer los asociados a las unidades de negocio asociadas al usuario
export const getWellsByUnitBussines = async (wellName, unitBussinesIds) => {
  const params = new URLSearchParams();

  if (wellName) params.set('name', wellName);

  const result = await apiYclickMaster.post(
    `/v1/Ubicaciones/pozos?${params.toString()}`,
    unitBussinesIds
  );

  return result.data;
};

// Trae las ubicaciones aunque allamos sellecionado o no una unidad de negocio en especifico
// Pero solo va a traer las asociados a las unidades de negocio asociadas al usuario
export const getUbicationsByUnitBussines = async (locationName, unitBussinesIds) => {
  const result = await apiYclickMaster.post(
    `/v1/Ubicaciones/locaciones?name=${locationName}`,
    unitBussinesIds
  );

  return result.data;
};

export const getUbicationsLocation = async (locationName, UnidadNegocioId) => {
  const result = await apiYclickMaster.get(
    `/v1/Ubicaciones/locaciones?name=${locationName}&unidadNegocioId=${UnidadNegocioId}`
  );

  return result.data;
};

// ------------------ OBJETO DE IMPUTACION ---------------------------------------------

export const getImputationObjectOyM = async (ubicationsIds) => {
  const result = await apiYclickMaster.post(
    'v1/Imputaciones/objetosImputacion/ubicacionesTecnicas',
    ubicationsIds
  );

  return result.data;
};

export const getImputationsObjects = async (idType, cod) => {
  const result = await apiYclickMaster.get(
    `/v1/Imputaciones/tipoImputacion/${idType}/objetosImputacion?codigo=${cod}`
  );

  return result.data;
};

export const getLocationsDetail = async (idLocation) => {
  const result = await apiYclickMaster.get(`/v1/Locaciones/${idLocation}/detalle`);

  return result.data;
};

export const getImputationsDetails = async (body) => {
  const result = await apiYclickMaster.post('/v1/Imputaciones/objetosImputacion/detalle', body);

  return result.data;
};

export const getImputationDefault = async (body) => {
  const result = await apiYclickMaster.post('/v1/Imputaciones/default', body);

  return result.data;
};

export const getImputationDetail = async (idTipo, idObjeto) => {
  const result = await apiYclickMaster.get(
    `/v1/Imputaciones/tipoImputacion/${idTipo}/objetoImputacion/${idObjeto}/detalle`
  );

  return result.data;
};

export const getBudgetService = async (objectImputacionId) => {
  const result = await apiYclickMaster.get(
    `/v1/Imputaciones/objetosImputacion/presupuesto?idObjetoImputacion=${objectImputacionId}`
  );

  return result.data;
};

export const getLogisticCenters = async (isPep, society = '') => {
  const result = await apiYclickMaster.get(
    `v1/Imputaciones/centros?esPep=${isPep}&sociedad=${society}`
  );

  return result.data;
};

export const getSocieties = async (isPep, logisticCenter = '') => {
  const result = await apiYclickMaster.get(
    `v1/Imputaciones/sociedades?esPep=${isPep}&centro=${logisticCenter}`
  );

  return result.data;
};

// ------------------ SERVICIOS -----------------------------------------------------------

export const getServicesWell = async (name, idEvento) => {
  const params = new URLSearchParams();

  if (idEvento) {
    params.append('idEvento', idEvento);
  }
  const result = await apiYclickMaster.get(`/v1/ServiciosPozo/${name}?${params.toString()}`);

  return result.data;
};

export const getServicesContract = async (contractId, eventId) => {
  const eventIdQueryParam = eventId ? `&idEvento=${eventId}` : '';
  const result = await apiYclickMaster.get(
    `/v1/Servicios/asociados?idContrato=${contractId}${eventIdQueryParam}`
  );

  return result.data;
};

export const getServices = async (name) => {
  const { data: services } = await apiYclickMaster.get(`/v1/ServiciosPozo/${name}`);

  return services;
};

// ------------------ PROVEEDORES -----------------------------------------------------------
export const getBusinessUnits = async () => {
  const result = await apiYclickMaster.get('/v1/UnidadesNegocio/me');

  return result.data;
};

export const getProvider = async () => {
  const result = await apiYclickMaster.get('/v1/Usuarios/proveedorNotificador/proveedor');

  return result.data;
};

// ------------------ COMUNICATE -----------------------------------------------------------

export const postDefaultReceivers = async (body) => {
  const result = await apiYclickMaster.post('/v1/Usuarios/destinatariosDefault', body);

  return result.data;
};

export const postOperationsReceivers = async (idBusinnesUnit, search) => {
  const result = await apiYclickMaster.post(
    `/v1/Usuarios/destinatariosOperaciones?busqueda=${search}`,
    idBusinnesUnit
  );

  return result.data;
};

export const postReceivers = async (idBusinnesUnit, search) => {
  const result = await apiYclickMaster.post(
    `/v1/Usuarios/destinatarios?busqueda=${search}`,
    idBusinnesUnit
  );

  return result.data;
};

// -------------------

/**
 * @returns {Promise<{id: number, nombre: stirng}[]>}
 */
export const getAllOperations = async () => {
  const result = await apiYclickMaster.get('/v1/UbicacionesTecnicas/Operaciones/todas');

  return result.data;
};

/**
 * @returns {Promise<{id: number, nombre: stirng}[]>}
 */

export const getOperationsByUser = async () => {
  const result = await apiYclickMaster.get('/v1/UbicacionesTecnicas/Operaciones/me/todas');

  return result.data;
};

export const getAllBusinessUnits = async () => {
  const result = await apiYclickMaster.get(`/v1/UnidadesNegocio/all`);

  return result.data;
};

export const supplierSS = async (value) => {
  const result = await apiYclickMaster.get(`/v1/Proveedores?nombre=${value}`);

  return result.data;
};

export const getEvents = async () => {
  const result = await apiYclickMaster.get(`/v1/Eventos`);

  return result.data;
};

export const getLaterEvents = async ({ wellId, eventTypeId, createDate }) => {
  const result = await apiYclickMaster.post('/v1/Eventos/posteriores', {
    pozoId: wellId,
    tipoEventoId: eventTypeId,
    fechaCreacion: formatFullDate(createDate, formatsEnum.FORMAT_DATE_2)
  });

  return result.data;
};

// TIPO DE UBICACIÓN

/**
 * @returns {Promise<{ id: number, nombre: string, tipoNegocio: { id: number, nombre: string, eventoId: number | null } }>}
 */
export const typeUbicationSS = async (includeGenericTypes = false) => {
  const params = new URLSearchParams();

  params.append('ubicacionesGenericas', includeGenericTypes ? 'true' : 'false');

  const result = await apiYclickMaster.get(`/v1/Ubicaciones/tipos?${params.toString()}`);

  return result.data;
};

export const getTeams = async (value) => {
  const params = new URLSearchParams();

  if (value) {
    params.append('nombreCorto', value);
  }
  const result = await apiYclickMaster.get(`/v1/Equipos?${params.toString()}`);

  return result.data;
};

export const getTypeOfEvents = async (id) => {
  const result = await apiYclickMaster.get(`/v1/Locaciones/${id}/tiposEventos`);

  return result.data;
};

export const getWellsDetail = async (id, tipoEventoId) => {
  const result = await apiYclickMaster.get(
    `/v1/Locaciones/${id}/tiposEventos/${tipoEventoId}/detalle`
  );

  return result.data;
};
export const getWellsAsociatedWithLocation = async (id, tipoEventoId) => {
  const result = await apiYclickMaster.get(
    `v1/Locaciones/${id}/tiposEventos/${tipoEventoId}/pozos`
  );

  return result.data;
};
export const getEventWellAsociatedWithWell = async (id, tipoEventoId) => {
  const result = await apiYclickMaster.get(
    `v1/Pozos/${id}/tiposEventos/${tipoEventoId}/eventosPozo`
  );

  return result.data;
};

export const getActiveOptions = async (body) => {
  const result = await apiYclickMaster.post(`/v1/UbicacionesTecnicas/descriptores/activos`, body);

  return result.data;
};

export const getWellEventDate = (body) => apiYclickMaster.post('/v1/Eventos/eventoPozos', body);

export const getCenters = async () => {
  const result = await apiYclickMaster.get(`/v1/Centros`);

  return result.data;
};

export const getImputationTypesService = async () => {
  const result = await apiYclickMaster.get('/v1/Imputaciones/tiposImputacion');

  return result.data;
};
